import React from 'react';
import Dashboard from './components/Dashboard';
// 2026-09-24: VarahiID sign-in. With VITE_AUTH_MODE=off both render nothing of their
// own (AuthProvider returns its children, UserMenu returns null), so the page is as before.
import AuthProvider from './auth/AuthProvider';
import UserMenu from './components/auth/UserMenu';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <Dashboard />
        <UserMenu />
      </div>
    </AuthProvider>
  );
}

export default App;
